import { useQuery } from "@tanstack/react-query";
import { Order } from "../types/order";
import orderCore from "../core/order.core";

export default function useGetOrder(orderId: string) {
  return useQuery<Order>({
    queryKey: ["orderSingle", orderId],
    queryFn: (context) => orderCore.getOrder(context.queryKey[1] as string),
    enabled: Boolean(orderId),
  });
}
